export default __webpack_public_path__ + "static/media/ivr_disabled.96497df9.svg";